export default __webpack_public_path__ + "static/media/virus.db3cf425.png";